import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import * as Sentry from "@sentry/react";
import './index.css'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://bb28f192f8a0cb495dae4244fd42266c@o182178.ingest.sentry.io/4505799667154944",
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
